function checkCartForSubscription() {
    const cartItems = document.querySelectorAll('.cart_scroll_con .cart_item');
    console.log("Cart items found:", cartItems.length);

    let hasSubscription = false;

    cartItems.forEach(function (item) {
        const itemUrlElement = item.querySelector('.item-url');
        if (itemUrlElement) {

            if (itemUrlElement.href.includes('selling_plan=')) {
                hasSubscription = true;
                console.log("Subscription product found:", itemUrlElement.href);
            }
        }
    });

    const cartTermsDiv = document.querySelector('.cart_terms');
    const checkoutButton = document.querySelector('button[name="checkout"]');
    const checkbox = document.getElementById('agree_terms');
    let customCheckboxabtest = document.querySelector('.custom-checkbox');
    const button1 = document.querySelector('.abtestCheckout1');
    const button2 = document.querySelector('.abtestCheckout2');

    if (hasSubscription) {
        console.log("Subscription products found, displaying cart_terms and disabling checkout");
        cartTermsDiv.style.display = 'flex';
        checkoutButton.disabled = true;
        checkoutButton.classList.add('disabled-checkout');
        button1.style.setProperty('display','none','important')
        button2.style.setProperty('display','block','important')


        if (checkbox) {
            checkbox.checked = true; 
            customCheckboxabtest.style.display = 'none'; 

            checkbox.removeEventListener('change', handleCheckboxChange);
            checkbox.addEventListener('change', handleCheckboxChange);

            const customCheckbox = document.querySelector('.custom-checkbox');
            if (customCheckbox) {
                customCheckbox.removeEventListener('click', toggleCustomCheckbox);
                customCheckbox.addEventListener('click', toggleCustomCheckbox);
            }

            if (checkbox.checked) {
                checkoutButton.disabled = false;
                checkoutButton.classList.remove('disabled-checkout');
            }
        }
    } else {
        console.log("No subscription products, hiding cart_terms and enabling checkout");
        cartTermsDiv.style.display = 'none';
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled-checkout');
        button1.style.setProperty('display','block','important')
        button2.style.setProperty('display','none','important')

        if (checkbox) {
            checkbox.style.display = ''; 
            checkbox.checked = false; 
        }
    }
}

function handleCheckboxChange(event) {
    const checkoutButton = document.querySelector('button[name="checkout"]');

    if (event.target.checked) {
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled-checkout');
    } else {
        checkoutButton.disabled = true;
        checkoutButton.classList.add('disabled-checkout');
    }
}



const parsePrice = (text) => parseFloat(text.replace(/[^0-9.-]+/g, "")) || 0;

function attachDiscountCodeHandler() {
  const discountButton = document.querySelector('#discount_code_button');
  const discountText   = document.querySelector('#discount_code_text');

  if (!discountButton || !discountText) return;

  const toggleButtonState = () => {
    discountButton.disabled = !discountText.value.trim();
  };

  discountText.addEventListener('input', toggleButtonState);
  discountButton.addEventListener('click', () => {
    const code = discountText.value.trim();
    if (!code) {
      discountButton.textContent = 'Enter Code';
      return;
    }

    discountButton.textContent = 'Applying...';
    discountButton.disabled = true;

    liquidAjaxCart.cartRequestUpdate({ discount: code });
  });

  toggleButtonState();
}

function totalSavings() {
  const originalPriceElement = document.querySelector('#ca_discount');
  const discountPriceElement = document.querySelector('#ca_price');
  const savingsWrapper       = document.querySelector('.ca_infoSavings');
  const savingsTextElement   = document.querySelector('.ca_savingsDiscount');

  if (!originalPriceElement || !discountPriceElement || !savingsTextElement || !savingsWrapper) return;

  const originalPrice = parsePrice(originalPriceElement.textContent);
  const discountPrice = parsePrice(discountPriceElement.textContent);

  if (originalPrice <= discountPrice) return;

  const savings = originalPrice - discountPrice;
  savingsTextElement.textContent = `$${savings.toFixed(2)}`;
  savingsWrapper.style.setProperty('display', 'block', 'important');
}


function toggleCustomCheckbox() {
    const checkbox = document.getElementById('agree_terms');
    checkbox.checked = !checkbox.checked;
    handleCheckboxChange({ target: checkbox });
}

function observeCartContent() {
    const cartContent = document.querySelector('.cart_content');

    const observer = new MutationObserver(() => {
        checkCartForSubscription();
        attachDiscountCodeHandler();
        totalSavings();

        observer.disconnect();
        observeCartContent();
    });

    if (cartContent) {
        console.log("Observing changes in cart_content");
        observer.observe(cartContent, { childList: true, subtree: true });
    } else {
        console.log("cart_content not found");
    }
}

document.addEventListener("DOMContentLoaded", function () {
    checkCartForSubscription();
    observeCartContent();

    document.addEventListener("ajax:success", function () {
        setTimeout(function () {
            checkCartForSubscription();
        }, 500);
    });
});